export default __webpack_public_path__ + "static/media/icon_message-4.02fea29d.svg";